import React from 'react' 
import Bredcom from '../../Bredcom/Main' 
import Header from '../../headerone/Main' 
import First from './First' 
import Brand from './Brand' 
 
function ComputerScienceEngineering() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="Computer Science Engineering" /> 
        <First/> 
        {/* <Brand/>  */}
    </> 
  ) 
} 
 
export default ComputerScienceEngineering 